import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { reasonLabel } from './BafaCheckBadge';

const AMPEL = {
  gruen: { label: 'Förderfähig', dot: 'bg-green-500', text: 'text-green-700' },
  gelb: { label: 'Bitte prüfen', dot: 'bg-amber-500', text: 'text-amber-700' },
  rot: { label: 'Nicht förderfähig', dot: 'bg-red-500', text: 'text-red-700' },
} as const;

export function BafaCheckPopup({
  open, ampel, reasons = [], onClose, pruefDauerMs = 6000,
}: {
  open: boolean;
  ampel?: string | null;
  reasons?: { code: string; severity: string }[];
  onClose: () => void;
  pruefDauerMs?: number;
}) {
  const [pruefen, setPruefen] = useState(true);
  useEffect(() => {
    if (!open) return;
    setPruefen(true);
    const t = setTimeout(() => setPruefen(false), pruefDauerMs);
    return () => clearTimeout(t);
  }, [open, pruefDauerMs]);

  if (!open) return null;
  const meta = (ampel && AMPEL[ampel as keyof typeof AMPEL]) || AMPEL.gelb;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="relative bg-white rounded-xl shadow-xl p-6 w-[min(90vw,420px)] text-center">
        {/* Schließen-Knopf immer verfügbar (auch während der Prüfung) — Popup schließt nie von selbst */}
        <button type="button" onClick={onClose} aria-label="Schließen"
          className="absolute top-2.5 right-2.5 text-slate-400 hover:text-slate-600">
          <X className="w-5 h-5" />
        </button>
        {pruefen ? (
          <div>
            <div className="mx-auto mb-3 w-8 h-8 border-2 border-purple-500 border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-slate-600">Förderfähigkeit wird geprüft…</p>
          </div>
        ) : (
          <div>
            <div className={`mx-auto mb-2 w-4 h-4 rounded-full ${meta.dot}`} />
            <p className={`text-lg font-semibold ${meta.text}`}>{meta.label}</p>
            {reasons.length > 0 && (
              <div className="mt-3 text-left">
                <p className="text-sm font-medium text-slate-700">Gründe:</p>
                <ul className="mt-1 text-sm text-slate-600 list-disc ml-5">
                  {reasons.map((r, i) => <li key={r.code ?? i}>{reasonLabel(r.code)}</li>)}
                </ul>
              </div>
            )}
            <button type="button" onClick={onClose}
              className="mt-4 px-4 py-2 bg-purple-600 text-white rounded-lg text-sm font-medium">Schließen</button>
          </div>
        )}
      </div>
    </div>
  );
}
